<template>
    <div class="modal-mask" v-show="show" transition="modal">
        <div class="modal-wrapper">
            <div class="modal-container" :style="{width: width, height: height}">

                <div class="new-modal-header" v-if="fullSlot === false">
                    <slot name="header">
                        default header
                    </slot>
                    <button class="new-close" type="button" @click="$emit('close')" v-tooltip :vtitle="closeLabel">
                        &times;
                    </button>
                </div>
                <div class="modal-body" v-if="fullSlot === false">
                    <slot name="body">
                        default body
                    </slot>
                </div>

                <div class="modal-footer" v-if="fullSlot === false">
                    <slot name="footer">
                        <button class="btn default" type="button" @click="$emit('close')">Fechar</button>
                        <button v-show="hideConfirmButton === false" class="btn blue" type="button" @click="$emit('confirm')">
                            {{ confirmText }}
                        </button>
                    </slot>
                </div>
                <template v-if="fullSlot === true">
                    <slot></slot>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewModal",
    props: {
        fullSlot: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            required: true,
        },
        width: {
            default: '300px'
        },
        height: {
            default: 'auto'
        },
        confirmText: {default: 'Confirmar'},
        hideConfirmButton: { default: false}
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
}

.new-modal-header {
    margin-top: 0;
    font-size: 18px;
    font-weight: 300;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border: 1px solid #EFEFEF;
    padding: 15px;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}
hr {
    margin: 0;
}

/*
 * the following styles are auto-applied to elements with
 * v-transition="modal" when their visiblity is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter, .modal-leave {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

</style>


// WEBPACK FOOTER //
// NewModal.vue?6cd36451